<template>
  <v-menu offset-y>
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <print-button />
      </div>
    </template>
    <v-list dense>
      <v-list-item @click="$emit('print', false)">
        <v-list-item-icon class="mr-2">
          <v-icon small>mdi-printer-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t("warehouse.print_without_stock") }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$emit('print', true)">
        <v-list-item-icon class="mr-2">
          <v-icon small>mdi-printer</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ $t("warehouse.print_with_stock") }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "WarehouseButtonPrintMenu",
};
</script>
